export default (link) => {
  const parentOpener = window.opener;
  window.opener = null;
  window.open(link, '_blank');
  window.opener = parentOpener;
};
